<template>
  <div class="m-2">
    <div class="text-center d-block">
      <b-img
        :src="face.media.url"
        style="width: 10rem; height: fit-content; margin: auto"
      />

      <p style="font-size: x-large; font-weight: 600" class="mt-1">
        {{ face.user_data }}
      </p>
    </div>

    <div class="text-center">
      <div 
        v-for="match in matches" :key="match.event_id"
        class="mt-1">
        <b-img
          :src="match.image"
          style="width: 10rem; height: fit-content; margin: auto"
        />

        <span class="ml-1">
          {{ `Similarity: ${(match.similarity * 100).toFixed(2)}%` }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton, BFormCheckbox } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onMounted } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    BButton,
    vSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    lunaMasterAccountId: {
      type: Number,
      required: true,
    },
    face: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    console.log(props.face);
    const matches = ref([]);
    const toast = useToast();

    onMounted(() => {
      console.log(props.face);
      let data = {
        face_id: props.face.face_id,
        limit: 3,
        threshold: 0.8,
        id_master_account: props.lunaMasterAccountId,
      };

      let dispatch = store.dispatch("luna_face/searchPerson", data);

      dispatch
        .then((response) => {
          if (response.success) {
            matches.value = response.data;
            console.log(response.data)
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    });

    return {
      matches,
    };
  },
};
</script>

<style lang="scss">
.full-width-custom {
  min-width: 60vw;
}

.image-container {
  position: relative;
  width: 100%;
  height: auto;
}

.b-sidebar-body::-webkit-scrollbar {
  display: none;
}
</style>
